export const MapTrackingState = {
  mapPresent: false
}


/** WEBPACK FOOTER **
 ** ./model/mapTrackingState.js
 **/